import { STATIC_ROUTES } from "./routes-static";

/** Turn a CatalogNode name into a URL-safe slug. */
export function slugify(name: string): string {
  return name
    .toLowerCase()
    .replace(/[áàäâ]/g, "a")
    .replace(/[éèëê]/g, "e")
    .replace(/[íìïî]/g, "i")
    .replace(/[óòöô]/g, "o")
    .replace(/[úùüû]/g, "u")
    .replace(/ñ/g, "n")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function publicRouteSlugFromSlug(slug: string): string {
  const clean = slug.replace(/^route-\d+-[a-z]-/, "") || slug;
  return clean.replace(/\bmachupicchu\b/g, "machu-picchu");
}

export function publicRouteSlugFromName(name: string): string {
  return publicRouteSlugFromSlug(slugify(name));
}

export function legacyRouteParamFor(input: { routeId: number | string; name: string }): string {
  return `${String(input.routeId).trim()}-${slugify(input.name)}`;
}

export function routeIdForMarketingParam(raw: string | null | undefined): string | null {
  const value = (raw ?? "").trim();
  const legacyId = /^(\d+)(?:-|$)/.exec(value)?.[1];
  if (legacyId) return legacyId;
  if (/^\d+$/.test(value)) return value;

  const staticRoute = STATIC_ROUTES.find((route) => {
    return (
      publicRouteSlugFromName(route.name) === value ||
      slugify(route.name) === value ||
      legacyRouteParamFor({ routeId: route.routeId, name: route.name }) === value
    );
  });

  return staticRoute ? String(staticRoute.routeId) : null;
}
